function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#12A24A;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M128,112.6c-28.7,0-52,25-52,55.9c0,4,0.4,7.8,1.1,11.5h19.6c-0.9-3.4-1.4-7-1.4-10.7 c0-20.7,14.6-37.6,32.7-37.6s32.7,16.8,32.7,37.6c0,3.7-0.5,7.3-1.4,10.7h19.5c0.7-3.7,1.1-7.6,1.1-11.5 C180,137.6,156.7,112.6,128,112.6z M128,58.4c-48.1,0-87,42.2-87,94.2c0,9.5,1.3,18.8,3.8,27.4h19.9c-3-8.5-4.7-17.8-4.7-27.4 c0-41.5,30.4-75.2,67.8-75.2c37.4,0,67.8,33.7,67.8,75.2c0,9.7-1.7,18.9-4.7,27.4h20.4c2.4-8.7,3.8-17.9,3.8-27.4 C215,100.6,176.1,58.4,128,58.4z M128,1.5C57.3,1.5,0,63.8,0,140.7c0,13.7,1.8,26.9,5.2,39.3h20.3c-3.8-12.3-5.9-25.6-5.9-39.3 c0-66.4,48.5-120.3,108.3-120.3c59.8,0,108.3,53.9,108.3,120.3c0,13.8-2.1,27-5.9,39.3h20.6c3.4-12.5,5.2-25.7,5.2-39.3 C256,63.8,198.7,1.5,128,1.5z"
});

var SvgOpmsLogo = function SvgOpmsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 180",
    style: {
      enableBackground: "new 0 0 256 180"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpmsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/opms_logo.557fe0bc.svg";
export { ForwardRef as ReactComponent };